import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  getDegree,
  getLanguage,
  getPenalty,
  getProficiency,
  getSkills,
} from "../../../../redux/categary/action";
import { GetCountry } from "../../../../redux/master/action";
import PAboutProject from "./Post-Project/PAboutProject";
import PSelectSkills from "./Post-Project/PSelectSkills";
import PDeadlineBudget from "./Post-Project/PDeadlineBudget";
import PExpectationPreferences from "./Post-Project/PExpectationPreferences";
import PReviewProject from "./Post-Project/PReviewProject";
import CAboutContest from "./PostContest/CAboutContest";
import CAddSkills from "./PostContest/CSelectSkills";
import CExpectationPreferences from "./PostContest/CExpectationPreferences";
import CReviewContest from "./PostContest/CReviewContest";
import JAboutJobs from "./PostJobs/JAboutJobs";
import JAddSkills from "./PostJobs/JSelectSkills";
import JExpectationPreferences from "./PostJobs/JExpectationPreferences";
import JReviewJobs from "./PostJobs/JReviewJobs";
import { checkMembershipPermissions } from "../../../../redux/permissions/UserPermissions";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { IS_TEST_MODE } from "../../../../assests/extention/commonfunction";

const CreatePost = (props) => {
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [modal, setModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const link = LoadCSSforfirstTime(path);

    return () => {
      if (link && document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, [path]);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getSkills());
    dispatch(getDegree());
    dispatch(getLanguage());
    dispatch(GetCountry());
    dispatch(getProficiency());
    dispatch(getPenalty());
  }, []);





  useEffect(() => {
    scrollToTop();
  }, [currentPage]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();
console.log(location.state,"locationlocation")
  const [formData, setFormData] = useState({
    title: "",
    price: "",
    type: location.state?.theType ? location.state?.theType : "1",
    is_ambrella: location.state?.response?.parent_id ? 1 : 0,
    ambrella_title: "",
    parent_id: parseInt(location.state?.response?.parent_id )|| "",
    category_id: "",
    sub_category_id: "",
    description: "",
    duration_type: "",
    duration: "",
    deliverables: "",
    language_id: "",
    last_date: "",
    hiring_type: "",
    work_location: "",
    country_id: "",
    city_name: "",
    skills: [],
    milestones: "",
    amount: "",
    penalty: "",
    files: [],
  });
console.log(location.state?.response?.id,"location.state?.response?.idlocation.state?.response?.id")

   // Inside CreatePost.js
useEffect(() => {
  setFormData((prevData) => ({
    ...prevData,
    type: location.state?.type || location.state?.theType || 1,
    // This will force "1" on ANY re-render if a response ID exists, even if the user unchecked it
    is_ambrella: location.state?.response?.parent_id ? 1 : prevData.is_ambrella, 
    parent_id:parseInt( location.state?.response?.parent_id || prevData.parent_id ),
  }));
}, [location.state]);


  const checkPermissions = async (posttype) => {
    try {
      const response = await dispatch(checkMembershipPermissions(posttype));

      if (!response?.status) {
        setModal(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    switch (formData.type) {
      case "1":
        checkPermissions("publish_project");
        break;
      case "2":
        checkPermissions("create_contest");
        break;
      case "3":
        checkPermissions("posting_jobs");
        break;
      default:
    }
  }, [formData?.type]);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const previousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      type: location.state?.theType,
    }));
  }, [location.state?.theType]);

  const renderPage = () => {
    if (formData?.type == 2) {
      switch (currentPage) {
        case 1:
          return (
            <CAboutContest
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 2:
          return (
            <CAddSkills
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 3:
          return (
            <CExpectationPreferences
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 4:
          return (
            <CReviewContest
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        default:
          return null;
      }
    }
    if (formData?.type == 3) {
      switch (currentPage) {
        case 1:
          return (
            <JAboutJobs
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 2:
          return (
            <JAddSkills
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 3:
          return (
            <JExpectationPreferences
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 4:
          return (
            <JReviewJobs
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        default:
          return null;
      }
    } else {
      switch (currentPage) {
        case 1:
          return (
            <PAboutProject
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 2:
          return (
            <PSelectSkills
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 3:
          return (
            <PDeadlineBudget
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 4:
          return (
            <PExpectationPreferences
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 5:
          return (
            <PReviewProject
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        default:
          return null;
      }
    }
  };

  return (
    <>
      {
        IS_TEST_MODE &&
        <>
          {currentPage < 9 ? (
            <>
              <button type="button" onClick={nextPage} className="next-button">
                Next
              </button>
              <button type="button" onClick={previousPage} className="next-button">
                Previous
              </button>
            </>
          ) : null}
        </>
      }
      <div>
        {renderPage()}
        <div className="button-container col-lg-8 col-md-11  mx-auto">
          {currentPage < 9 ? <></> : <></>}
        </div>
      </div>
      <Modal
        isOpen={modal}
        backdrop="static"
        keyboard={false}
        className="modal-centered popupmodal"
      >
        <ModalBody>
          <h4>Upgrade your account</h4>
          <p>
            Please purchase a membership to create posts and access exclusive
            features.
          </p>
        </ModalBody>
        <div className="modal-footer" style={{ marginBottom: 10 }}>
          <button
            onClick={() => {
              setModal((state) => !state);
              navigate(-1);
            }}
            className="btn"
            style={{ background: "#fff", color: "black", border: "2px solid " }}
            type="submit"
          >
            Go Back
          </button>
        </div>
        <div className="modal-footer mt-3">
          <button
            className="btn "
            onClick={() => {
              setModal((state) => !state);
              navigate(`/${lan}/account/upgrademembership`, { state: { returnUrl: window.location.pathname + window.location.search } });
            }}
          >
            Buy Membership
          </button>
        </div>
      </Modal>
    </>
  );
};

export default CreatePost;
